import { render, staticRenderFns } from "./devis_reference.vue?vue&type=template&id=66b4e133&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./devis_reference.vue?vue&type=script&lang=js"
export * from "./devis_reference.vue?vue&type=script&lang=js"
import style0 from "./devis_reference.vue?vue&type=style&index=0&id=66b4e133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b4e133",
  null
  
)

export default component.exports